<template>
  <div id="luck">
    <van-row class="luck_shop">
      <van-col span="24" v-for="(l) in list" :key="l.id">
        <van-col span="24" class="luck_shop_name">{{ l.figure }}{{ $t('column.good_number')}}</van-col>
        <van-col span="12" class="luck_type" v-for="(c) in l.list" :key="c.id">
          <van-col span="24" class="luck_div">
            <van-col span="24" class="luck_div_name">{{ c.luck_num }}</van-col>
            <van-col span="24" class="luck_div_sum">{{ c.price }} <img :src="consumer_price_Icon"/></van-col>
            <van-col span="18" offset="3" class="luck_btn" @click="luck_btn(c.id, c.price)">{{ $t('btn.purchase')}}</van-col>
          </van-col>
        </van-col>
      </van-col>
    </van-row>
  </div>
</template>
<script>

  import '@/assets/css/style.css'
  import axios from 'axios'
  import Toast from "vant/lib/toast"
  import { Dialog } from 'vant'
  export default {
    data() {
      return {
        list:[],
        diamonds_name: '',
        consumer_price_Icon: '',
      }
    },
    created: function() {
      this.convert();
      document.title = this.$t('title.shop')
    },
    components: {
      [Dialog.name]: Dialog
    },
    methods: {
      convert: function() {
        const uid = this.$route.query.uid
        const token = this.$route.query.token
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=luck&act=index", {
          params : {
            user_id: uid,
            token: token
          }
        }).then(res =>{
          console.log(res.data)
          this.list = res.data.type
          this.diamonds_name = res.data.diamonds_name
          this.consumer_price_Icon = res.data.consumer_price_Icon
          if (res.data.status === 0) {
            Toast(res.data.error)
            return false
          }
        })
      },
      luck_btn (id, type) {
        const name =  this.$t('Tips.is_buy_a_good_number')
        Dialog.confirm({
          title: this.$t('Tips.buy_good_number'),
          message: name,
          confirmButtonText: this.$t('btn.confirm'),
          cancelButtonText: this.$t('btn.cancel'),
        }).then(() => {
          const uid = this.$route.query.uid
          const token = this.$route.query.token
          axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=luck&act=upd", {
            params : {
              user_id: uid,
              token: token,
              id: id,
              type : type
            }
          }).then(res =>{
            console.log(res.data)
            Toast(res.data.error)
            if (res.data.status === 1) {
              this.convert()
            }
          })
        }).catch(() => {
          // on cancel
        })
      }
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/luck.vue